// extracted by mini-css-extract-plugin
module.exports = {"link":"LogoHeader_link__2nxY8"};